"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.406 10c.618 1.104 1.493 2.13 2.485 2.877 1.003.754 2.082 1.19 3.109 1.19s2.106-.436 3.109-1.19c.992-.746 1.867-1.773 2.485-2.877-.618-1.104-1.492-2.13-2.485-2.877-1.003-.754-2.082-1.19-3.109-1.19s-2.106.436-3.109 1.19C5.898 7.869 5.024 8.896 4.406 10M6.05 6.004C7.213 5.129 8.58 4.532 10 4.532s2.787.597 3.95 1.472c1.167.877 2.173 2.067 2.88 3.338.227.41.227.907 0 1.316-.707 1.272-1.713 2.46-2.88 3.338-1.163.875-2.53 1.471-3.95 1.471s-2.787-.596-3.95-1.47c-1.167-.878-2.173-2.068-2.88-3.339a1.36 1.36 0 0 1 0-1.316c.707-1.272 1.713-2.46 2.88-3.338m4.947 3.053a1.44 1.44 0 0 0-1.994 0 1.304 1.304 0 0 0 0 1.886 1.44 1.44 0 0 0 1.994 0 1.304 1.304 0 0 0 0-1.886m-2.97-1.004a2.84 2.84 0 0 1 3.946 0 2.704 2.704 0 0 1 0 3.893 2.84 2.84 0 0 1-3.946 0 2.704 2.704 0 0 1 0-3.893",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=EyeShowIcon20.js.map